import { useRef, useCallback, useEffect } from 'react';

export const getSessionId = () => {
  const key = 'form_tracking_session';
  let id = sessionStorage.getItem(key);
  if (!id) {
    id = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    sessionStorage.setItem(key, id);
  }
  return id;
};

export const getPersistentId = () => {
  const key = 'form_tracking_user';
  let id = localStorage.getItem(key);
  if (!id) {
    id = `u-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    localStorage.setItem(key, id);
  }
  return id;
};

const useFormTracking = (stepNumber = 0) => {
  const sessionId    = useRef(getSessionId());
  const persistentId = useRef(getPersistentId());
  const stepStartTime = useRef(Date.now());

  const send = (payload) => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/tracking/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(() => {});
  };

  const track = useCallback(
    (eventName, { fieldName = null } = {}) => {
      const timeSpent = Math.round((Date.now() - stepStartTime.current) / 1000);
      send({
        sessionId:    sessionId.current,
        persistentId: persistentId.current,
        eventName,
        fieldName,
        stepNumber,
        timeSpent,
      });
    },
    [stepNumber]
  );

  const resetStepTimer = useCallback(() => {
    stepStartTime.current = Date.now();
  }, []);

  useEffect(() => {
    const handleAbandonment = () =>
      navigator.sendBeacon(
        `${process.env.REACT_APP_API_BASE_URL}/tracking/event`,
        new Blob(
          [JSON.stringify({
            sessionId:    sessionId.current,
            persistentId: persistentId.current,
            eventName:    'form_abandoned',
            fieldName:    null,
            stepNumber,
            timeSpent:    Math.round((Date.now() - stepStartTime.current) / 1000),
          })],
          { type: 'application/json' }
        )
      );

    window.addEventListener('beforeunload', handleAbandonment);
    return () => window.removeEventListener('beforeunload', handleAbandonment);
  }, [stepNumber]);

  return { track, resetStepTimer };
};

export default useFormTracking;
